var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"box-card"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("欢迎")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }